import type { LocalMonth, LocalQuarter } from '@ergo/shared';

/**
 * Les quatre clés `ergo:*` du navigateur, rassemblées ici pour qu'on les voie d'un
 * coup. Ce ne sont jamais des données du cabinet — une fête déjà tombée, un relevé
 * déjà passé — et elles se perdent sans conséquence : ni purge, ni version. Changer
 * une de ces chaînes ferait tout oublier au navigateur d'elle.
 */
export const storageKey = {
  /** Les pétales du mois bouclé, une seule fois par mois. */
  moisBoucle: (month: LocalMonth) => `ergo:mois-bouclé:${month}`,
  /** Les pétales du trimestre déclaré, une seule fois par trimestre. */
  trimestreDeclare: (quarter: LocalQuarter) => `ergo:trimestre-déclaré:${quarter}`,
  /** Les familles déjà rapprochées pendant le relevé. */
  releve: (quarter: LocalQuarter) => `ergo:relevé:${quarter}`,
  /** L'étape « Voir le chiffre » franchie. */
  releveEtape: (quarter: LocalQuarter) => `ergo:relevé-étape:${quarter}`,
};
